import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  OnInit,
  OnDestroy,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NavItem } from '../../model/nav-item';
import { NavService } from '../../nav.service';

@Component({
  selector: 'navigation-item',
  templateUrl: './navigation-item.component.html',
  styleUrls: [],
  animations: [
    trigger('indicatorRotate', [
      state('collapsed', style({ transform: 'rotate(0deg)' })),
      state('expanded', style({ transform: 'rotate(180deg)' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4,0.0,0.2,1)')
      ),
    ]),
  ],
})
export class NavigationItemComponent implements OnInit, OnChanges, OnDestroy {
  @Output() toggleMobileLink: any = new EventEmitter<void>();
  @Output() notify: EventEmitter<boolean> = new EventEmitter<boolean>();

  expanded: any = false;
  disabled: any = false;
  twoLines: any = false;
  @HostBinding('attr.aria-expanded') ariaExpanded = this.expanded;
  @Input() item: NavItem | any;
  @Input() depth: any;

  private urlSubscription: Subscription;

  constructor(public navService: NavService, public router: Router) {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }

  ngOnInit() {
    this.checkCurrentRoute();
  }

  ngOnChanges() {
    this.checkCurrentRoute();
  }

  ngOnDestroy() {
    if (this.urlSubscription) {
      this.urlSubscription.unsubscribe();
    }
  }

  private checkCurrentRoute() {
    if (this.urlSubscription) {
      this.urlSubscription.unsubscribe();
    }

    this.urlSubscription = this.navService.currentUrl.subscribe(
      (url: string) => {
        if (url && this.item) {
          const shouldExpand = this.shouldExpandForUrl(url, this.item);
          this.expanded = shouldExpand;
          this.ariaExpanded = shouldExpand;
        }
      }
    );
  }

  private shouldExpandForUrl(url: string, item: any): boolean {
    if (!item.children || !item.children.length) {
      return false;
    }

    // Check if current item's route matches
    if (item.route && url.indexOf(item.route) >= 0) {
      return true;
    }

    // Check if any child route matches current URL
    return item.children.some((child: any) => {
      if (child.route && url.indexOf(child.route) >= 0) {
        return true;
      }
      // Recursively check nested children
      return this.shouldExpandForUrl(url, child);
    });
  }

  onItemSelected(item: NavItem) {
    if (!item.children || !item.children.length) {
      this.router.navigate([item.route]);
    }
    if (item.children && item.children.length) {
      this.expanded = !this.expanded;
    }
    //scroll
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    if (!this.expanded) {
      if (window.innerWidth < 1024) {
        this.notify.emit();
      }
    }
  }

  onSubItemSelected(item: NavItem) {
    if (!item.children || !item.children.length) {
      if (this.expanded && window.innerWidth < 1024) {
        this.notify.emit();
      }
    }
  }
}
